import React, { useMemo, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Tabs } from '../root/components/common'
import Users from './users'
import Roles from './roles'
import { useSelector } from 'react-redux'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { CompareArrowsOutlined } from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: 'calc(100% - 65px)'
    },
    tabs: {
        marginBottom: 15
    }
}))

export default function UserManagement() {
    const classes = useStyles()
    const history = useHistory()
    const { tabName = 'users' } = useParams()
    const { locale } = useSelector(state => state.main)

    const tabs = {
        users: {
            key: 'users',
            name: locale.userManagement.users
        },
        roles: {
            key: 'roles',
            name: locale.userManagement.roles
        }
    }

    const onTabChange = tab => {
        history.push(`/user-management/${tab}`)
    }

    return (
        <div className={classes.wrapper}>
            <Tabs
                className={classes.tabs}
                tabs={tabs}
                currentTab={tabName}
                setCurrentTab={onTabChange}
            />
            {tabName === tabs.users.key && <Users />}
            {tabName === tabs.roles.key && <Roles />}
        </div>
    )
}
